import React, {useState, useContext, useEffect, useRef} from 'react';
import styled from 'styled-components';
import {OverlayContext} from '../../../contexts/OverlayContext';
import {useParams} from 'react-router-dom';

import {SILVERTREE, OzButton} from "@ozwol/webui";

import WorkspaceService from './../../../services/WorkspaceService';
 
import Menu from './Menu';
import ButtonWithAlert from './../../../components/ButtonWithAlert';
import OverlayUpload from './OverlayUpload';
import PopupUploadPolling from './PopupUploadPolling';


const Form = styled.form`
	display: flex;
	flex-direction: row;
	width: 100%;
	max-width: 100%;

	& input{
		display: none;
	}
`;

const Label = styled.label`
	height: 100%;
	// background-color: ${props => props.dragActive ? "#ffffff" : "#f8fafc"};

	& span{
		display: inline-block !important;
	}
`;
const Cover = styled.button`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0px;
	right: 0px;
	bottom: 0px;
	left: 0px;
	border: 0;
	background-color: ${SILVERTREE}33;
`;
const RowButton = styled.div`
	margin-top: 3px;
  & > *{
		opacity: 0;
	}

	div:hover > form > & > *{
		opacity: 1;
	}
`;

const traverseFileTree = (item, path = "") => {
  if (item.isFile) {
    return new Promise((resolve) => {
      item.file((file) => {
        file.path = file.webkitRelativePath ? file.webkitRelativePath : path + file.name;
        resolve([file]);
      });
    });
  } else if (item.isDirectory) {
    const dirReader = item.createReader();
    return new Promise((resolve) => {
      dirReader.readEntries((entries) => {
        let promises = entries.map((entry) =>
          traverseFileTree(entry, path + item.name + "/")
        );
        Promise.all(promises).then((results) => {
          // results è un array di array => flat
          resolve([].concat(...results));
        });
      });
    });
  } else {
    return Promise.resolve([]);
  }
};

const FileUpload = ({filesPaths, fullPath, refreshList, retryFolder, purgeFolder, openPaths, setOpenPaths, children}) => {
  const {addOverlay, replaceOverlay, removeOverlay} = useContext(OverlayContext);
  const [dragActive, setDragActive] = useState(false);
	const inputRef = React.useRef(null);
	const {projectUuid} = useParams();
	const dragTimeoutRef = useRef(null);

  const dragActiveRef = React.useRef(false);
  useEffect(() => {
    dragActiveRef.current = dragActive;
  }, [dragActive]);
	
// useEffect(() => {
// }, [inputRef]);

  const handleDrag = function(e) {
		e.preventDefault();
		e.stopPropagation();
		if (e.type === "dragenter" || e.type === "dragover") {
			setDragActive(true);
			if (!openPaths.includes(fullPath)) {
				if (dragTimeoutRef.current) {
					clearTimeout(dragTimeoutRef.current);
				}
				dragTimeoutRef.current = setTimeout(() => {
					if (dragActiveRef.current) {
						setOpenPaths([...openPaths, fullPath]);
					}
					dragTimeoutRef.current = null;
				}, 500);
			}
		} else if (e.type === "dragleave") {
			setDragActive(false);
			if (dragTimeoutRef.current) {
				clearTimeout(dragTimeoutRef.current);
				dragTimeoutRef.current = null;
			}
		}
  };

	const handleDrop = function(e) {
		if(!openPaths.includes(fullPath)){
			setOpenPaths([...openPaths, fullPath]);
		}
		e.preventDefault();
		e.stopPropagation();
		setDragActive(false);
		// console.log(e.dataTransfer);

		let items = e.dataTransfer.items;
		let promises = [];

		for (let i = 0; i < items.length; i++) {
			let item = items[i].webkitGetAsEntry();
			if (item) {
				promises.push(traverseFileTree(item));
			}
		}

		Promise.all(promises).then((results) => {
			// Flatten the array of arrays
			let fileQueue = [].concat(...results);
			addOverlay({
			reference: "overlayUpload",
			type: "modal",
			content: <OverlayUpload
					projectUuid={projectUuid}
					fullPath={fullPath}
					files={fileQueue}
					fnUpload={upload}
					fromDnD={true}
				/>,
			});
			// qui puoi chiamare una funzione tipo preupload(fileQueue);
		});

		// if (e.dataTransfer.files && e.dataTransfer.files[0]) {
		// 	upload(e.dataTransfer.files);
		// }
	};

	const handleChange = function(e) {
		e.preventDefault();
		if (e.target.files) {		
			let files = Array.from(e.target.files);	
			for (let i = 0; i < files.length; i++) {
				files[i].path = files[i].webkitRelativePath ? files[i].webkitRelativePath : files[i].name;
			}

			addOverlay({
			reference: "overlayUpload",
			type: "modal",
			content: <OverlayUpload
					projectUuid={projectUuid}
					fullPath={fullPath}
					files={files}
					fnUpload={upload}
					fromDnD={false}
				/>,
			});
		}
	};

	
  const upload = (files) => {
		removeOverlay("overlayUpload");
		addOverlay({
			reference: "uploadPolling",
			type: "popup",
			content: <PopupUploadPolling />,
		});
    for (var i = 0; i < files.length; i++) { 
      if(files[i].path){
        let folders = files[i].path.replace("/"+files[i].name, "").split("/");
        for (var j = 0; j < folders.length; j++) { 
          // WorkspaceService.createFolder(path.length > 0 ? path+"/" : "", folders.slice(0, j+1).join("/"));
        }
      }

      if(files[i].size === 0){
        // WorkspaceService.createFolder(path.length > 0 ? path+"/" : "", files[i].name, files[i]);
      }else{
				// promises.push(WorkspaceService.upload(fullPath.length > 0 ? fullPath+"/" : "", files[i].webkitRelativePath ? files[i].webkitRelativePath : files[i].name, files[i]));
				WorkspaceService.upload(fullPath.length > 0 ? fullPath+"/" : "", files[i].path, files[i]).then(() => {
					refreshList();
					replaceOverlay({
						reference: "uploadPolling",
						type: "popup",
						content: <PopupUploadPolling />,
					}, "uploadPolling");
				});
      }
    }

		// Promise.all(promises).then((values) => {
		// 	console.log(values.length + " === " + files.length);
		// 	if(values.length === files.length){
				
		// 		console.log("refresh");
		// 		refreshList();
		// 	}
		// 	// refreshList();
		// });
  };
	

	return (
    <Form onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
		<input 
			ref={inputRef} 
			type="file" 
			onChange={handleChange} 
			multiple
		/>
      <Label>
				{children}				
      </Label>

			<RowButton>
				<Menu list={[
					<OzButton 
						variant="push-black" 
						size="small" 
						onClick={(e) => {
							if (inputRef.current !== null) {
									inputRef.current.removeAttribute("directory", "");
									inputRef.current.removeAttribute("webkitdirectory", "");
									inputRef.current.click();
									setOpenPaths([...openPaths, fullPath]);
							}
						}}
					>
						<span className="material-symbols-outlined">upload_file</span> Upload files
					</OzButton>,
					<OzButton 
						variant="push-black" 
						size="small" 
						onClick={(e) => {
							if (inputRef.current !== null) {
								inputRef.current.setAttribute("directory", "");
								inputRef.current.setAttribute("webkitdirectory", "");
								inputRef.current.click();
								setOpenPaths([...openPaths, fullPath]);
							}
						}}
					>
						<span className="material-symbols-outlined">drive_folder_upload</span> Upload folders
					</OzButton>,
					filesPaths.filter((item => item.Key.startsWith(fullPath+"/"))).length > 0 ? 
						<ButtonWithAlert
							title="Do you confirm you want to re-process the folder?"
							onConfirm={() => retryFolder(fullPath)}
						>         
							<OzButton 
								variant="push-black" 
								size="small" 
							>
								<span className="material-symbols-outlined">redo</span> Retry
							</OzButton>
						</ButtonWithAlert>
					: null,
					filesPaths.filter((item => item.Key.startsWith(fullPath+"/"))).length > 0 ? 
						<ButtonWithAlert
							title="Do you confirm you want to clean up this folder?"
							text="This operation cannot be undone"
							confirmLabel="Type DELETE to confirm your choice"
							confirmField="DELETE"
							onConfirm={() => purgeFolder(fullPath)}
						>         
							<OzButton 
								variant="push-black" 
								size="small" 
							>
								<span className="material-symbols-outlined">cancel</span> Clean up
							</OzButton>
						</ButtonWithAlert>
					: null					
				]}/>
			</RowButton>

			{ dragActive && <Cover onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></Cover> }
    </Form>
	)
}

export default FileUpload;